import React, { useContext, useMemo, useState } from 'react';
import { SearchContext } from "../../context/SearchContext.js";
import { SettingsContext } from "../../context/SettingsContext.js";
import { useFilteredItems } from "../../hooks/useFilteredItems.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchProvider({
  children,
  externalSearchString,
  items
}) {
  const {
    inlineSearch,
    filterFn
  } = useContext(SettingsContext);
  const [searchString, setSearchString] = useState('');
  const stringToSearch = externalSearchString ?? (inlineSearch ? searchString : undefined);
  const isFiltered = !!stringToSearch;
  const filteredItems = useFilteredItems(items, stringToSearch, filterFn);
  const value = useMemo(() => ({
    setSearchString,
    searchString: stringToSearch,
    isFiltered,
    filteredItems
  }), [setSearchString, stringToSearch, isFiltered, filteredItems]);
  return /*#__PURE__*/_jsx(SearchContext.Provider, {
    value: value,
    children: children
  });
}